/**
 * Omniture Tracking Identifiers
 *
 * Centralized constants for all prop54 click and page load tracking values.
 * Naming: CATEGORY_ACTION (e.g., FLIGHTS_LISTING_LOADED)
 */

export const TRACKING_IDS = {
  // ── Flights: Page Load ──
  FLIGHTS_LISTING_LOADED: 'mmt_ai_flight_listing_loaded',
  FLIGHTS_DETAILS_LOADED: 'mmt_ai_flight_details_loaded',
  FLIGHTS_REVIEW_LOADED: 'mmt_ai_flight_review_loaded',
  FLIGHTS_BOOKED: 'mmt_ai_flight_booked',

  // ── Flights: Click ──
  FLIGHTS_CARD_CLICKED: 'mmt_ai_flight_card_clicked',

  // ── Hotels/Stay: Page Load ──
  STAY_LISTING_LOADED: 'mmt_ai_stay_listing_loaded',
  STAY_DETAILS_LOADED: 'mmt_ai_stay_details_loaded',
  STAY_REVIEW_LOADED: 'mmt_ai_stay_review_loaded',
  STAY_BOOKED: 'mmt_ai_stay_booked',

  // ── Hotels/Stay: Click ──
  STAY_CARD_CLICKED: 'mmt_ai_stay_card_clicked',

  // ── Chat: Page Load ──
  CONVERSATION_STARTED: 'mmt_ai_conversation_started',

  // ── Chat: Click ──
  CHAT_SEND_MESSAGE_CLICK: 'mmt_ai_send_message_click',
  CHAT_PANE_SIZE_INCREASED: 'mmt_ai_chat_pane_size_increased',
  CHAT_PANE_SIZE_REDUCED: 'mmt_ai_chat_pane_size_reduced',

  // ── Home Page: Page Load ──
  SUGGESTED_PROMPTS_SHOWN: 'mmt_ai_suggested_prompts_shown',
  MAP_SHOWN: 'mmt_ai_map_shown',

  // ── Home Page: Click ──
  VOICE_CLICKED: 'mmt_ai_voice_clicked',
  VOICE_INPUT_RECEIVED: 'mmt_ai_voice_input_received',
} as const;
